export const PERMISSIONS = {
  // Invoices - General
  INVOICE_VIEW: "Invoice.View",
  INVOICE_CREATE: "Invoice.Create",
  INVOICE_EDIT: "Invoice.Edit",
  INVOICE_DELETE: "Invoice.Delete",
  INVOICE_PRINT: "Invoice.Print",

  // 1. Sales
  INVOICE_SALES_VIEW: "Invoice.Sales.View",
  INVOICE_SALES_CREATE: "Invoice.Sales.Create",
  INVOICE_SALES_EDIT: "Invoice.Sales.Edit",
  INVOICE_SALES_DELETE: "Invoice.Sales.Delete",
  INVOICE_SALES_PRINT: "Invoice.Sales.Print",
  INVOICE_SALES_APPROVE: "Invoice.Sales.Approve",

  // 2. Purchase
  INVOICE_PURCHASE_VIEW: "Invoice.Purchase.View",
  INVOICE_PURCHASE_CREATE: "Invoice.Purchase.Create",
  INVOICE_PURCHASE_EDIT: "Invoice.Purchase.Edit",
  INVOICE_PURCHASE_DELETE: "Invoice.Purchase.Delete",
  INVOICE_PURCHASE_PRINT: "Invoice.Purchase.Print",
  INVOICE_PURCHASE_APPROVE: "Invoice.Purchase.Approve",

  // 3. Sales Return
  INVOICE_SALES_RETURN_VIEW: "Invoice.SalesReturn.View",
  INVOICE_SALES_RETURN_CREATE: "Invoice.SalesReturn.Create",
  INVOICE_SALES_RETURN_EDIT: "Invoice.SalesReturn.Edit",
  INVOICE_SALES_RETURN_DELETE: "Invoice.SalesReturn.Delete",
  INVOICE_SALES_RETURN_PRINT: "Invoice.SalesReturn.Print",
  INVOICE_SALES_RETURN_APPROVE: "Invoice.SalesReturn.Approve",

  // 4. Purchase Return
  INVOICE_PURCHASE_RETURN_VIEW: "Invoice.PurchaseReturn.View",
  INVOICE_PURCHASE_RETURN_CREATE: "Invoice.PurchaseReturn.Create",
  INVOICE_PURCHASE_RETURN_EDIT: "Invoice.PurchaseReturn.Edit",
  INVOICE_PURCHASE_RETURN_DELETE: "Invoice.PurchaseReturn.Delete",
  INVOICE_PURCHASE_RETURN_PRINT: "Invoice.PurchaseReturn.Print",
  INVOICE_PURCHASE_RETURN_APPROVE: "Invoice.PurchaseReturn.Approve",

  // Invoices - Quotation
  INVOICE_QUOTATION_VIEW: "Invoice.Quotation.View",
  INVOICE_QUOTATION_CREATE: "Invoice.Quotation.Create",

  // 7. Opening Stock
  INVOICE_OPENING_STOCK_VIEW: "Invoice.OpeningStock.View",
  INVOICE_OPENING_STOCK_CREATE: "Invoice.OpeningStock.Create",
  INVOICE_OPENING_STOCK_EDIT: "Invoice.OpeningStock.Edit",
  INVOICE_OPENING_STOCK_DELETE: "Invoice.OpeningStock.Delete",
  INVOICE_OPENING_STOCK_PRINT: "Invoice.OpeningStock.Print",
  INVOICE_OPENING_STOCK_APPROVE: "Invoice.OpeningStock.Approve",

  // 8. Stock In
  INVOICE_STOCK_IN_VIEW: "Invoice.StockIn.View",
  INVOICE_STOCK_IN_CREATE: "Invoice.StockIn.Create",
  INVOICE_STOCK_IN_EDIT: "Invoice.StockIn.Edit",
  INVOICE_STOCK_IN_DELETE: "Invoice.StockIn.Delete",
  INVOICE_STOCK_IN_PRINT: "Invoice.StockIn.Print",
  INVOICE_STOCK_IN_APPROVE: "Invoice.StockIn.Approve",

  // 9. Stock Out
  INVOICE_STOCK_OUT_VIEW: "Invoice.StockOut.View",
  INVOICE_STOCK_OUT_CREATE: "Invoice.StockOut.Create",
  INVOICE_STOCK_OUT_EDIT: "Invoice.StockOut.Edit",
  INVOICE_STOCK_OUT_DELETE: "Invoice.StockOut.Delete",
  INVOICE_STOCK_OUT_PRINT: "Invoice.StockOut.Print",
  INVOICE_STOCK_OUT_APPROVE: "Invoice.StockOut.Approve",

  // Products
  PRODUCT_VIEW: "Product.View",
  PRODUCT_CREATE: "Product.Create",
  PRODUCT_EDIT: "Product.Edit",
  PRODUCT_DELETE: "Product.Delete",

  // Customers
  CUSTOMER_VIEW: "Customer.View",
  CUSTOMER_CREATE: "Customer.Create",
  CUSTOMER_EDIT: "Customer.Edit",
  CUSTOMER_DELETE: "Customer.Delete",

  // Suppliers
  SUPPLIER_VIEW: "Supplier.View",
  SUPPLIER_CREATE: "Supplier.Create",
  SUPPLIER_EDIT: "Supplier.Edit",
  SUPPLIER_DELETE: "Supplier.Delete",

  // Reports
  REPORT_VIEW: "Report.View",

  // Warehouse & Stock
  STOCK_MOVE: "Stock.Move",
  UNIT_MANAGE: "Unit.Manage",
  CATEGORY_MANAGE: "Category.Manage",

  // Accounts & Finance
  CHART_OF_ACCOUNTS_VIEW: "ChartOfAccounts.View",
  CHART_OF_ACCOUNTS_CREATE: "ChartOfAccounts.Create",
  CHART_OF_ACCOUNTS_EDIT: "ChartOfAccounts.Edit",
  CHART_OF_ACCOUNTS_DELETE: "ChartOfAccounts.Delete",
  
  // GL Settings
  GL_SETTINGS_VIEW: "GlSettings.View",
  GL_SETTINGS_EDIT: "GlSettings.Edit",

  VOUCHER_VIEW: "Voucher.View",
  VOUCHER_CREATE: "Voucher.Create",

  // Bonds - Receipt
  BOND_RECEIPT_VIEW: "Bond.Receipt.View",
  BOND_RECEIPT_CREATE: "Bond.Receipt.Create",
  BOND_RECEIPT_EDIT: "Bond.Receipt.Edit",
  BOND_RECEIPT_DELETE: "Bond.Receipt.Delete",
  BOND_RECEIPT_PRINT: "Bond.Receipt.Print",

  // Bonds - Payment
  BOND_PAYMENT_VIEW: "Bond.Payment.View",
  BOND_PAYMENT_CREATE: "Bond.Payment.Create",
  BOND_PAYMENT_EDIT: "Bond.Payment.Edit",
  BOND_PAYMENT_DELETE: "Bond.Payment.Delete",
  BOND_PAYMENT_PRINT: "Bond.Payment.Print",

  // Bonds - Tax
  BOND_TAX_CREATE: "Bond.Tax.Create",
 
  SAFE_VIEW: "Safe.View",
  BANK_VIEW: "Bank.View",
  PAYMENT_METHOD_VIEW: "PaymentMethod.View",
  
  // list voucher

  VOUCHER_VIEW:"VOUCHER_VIEW",
  // Journal Entries
  JOURNAL_ENTRY_VIEW: "JournalEntry.View",
  JOURNAL_ENTRY_CREATE: "JournalEntry.Create",
  JOURNAL_ENTRY_EDIT: "JournalEntry.Edit",
  JOURNAL_ENTRY_DELETE: "JournalEntry.Delete",
  JOURNAL_ENTRY_POST: "JournalEntry.Post",

  // Accounting Reports
  ACCOUNT_STATEMENT_VIEW: "Report.AccountStatement.View",
  TRIAL_BALANCE_VIEW: "Report.TrialBalance.View",
  BALANCE_SHEET_VIEW: "Report.BalanceSheet.View",
  INCOME_STATEMENT_VIEW: "Report.IncomeStatement.View",

  // Settings
  SETTINGS_VIEW: "Settings.View",
  SETTINGS_EDIT: "Settings.Edit",

  // Roles & Users
  ROLE_MANAGE: "Role.Manage",
  USER_MANAGE: "User.Manage",
};
